module.exports = __webpack_public_path__ + "img/login-img.87830e19.jpg";